import { createApp } from 'vue'
import Iban from './Iban.vue'
import './assets/global.css'

createApp(Iban).mount('#iban')
